// Registry of not-yet-built capabilities from the Enterprise GRC target menu
// (Staging Gap Review & Recommended Target Menu). Each entry gets one route +
// one shared placeholder page (see views/shared/ComingSoonPage.vue) so the
// full target navigation is reachable now, ahead of real implementation.
export type StubPriority = "P0" | "P1" | "P2";

export interface StubPageConfig {
  key: string;
  label: string;
  section: string;
  description: string;
  priority?: StubPriority;
}

export const STUB_PAGES: Record<string, StubPageConfig> = {
  // My Work (RCS-134) is fully built — see config/myWorkSources.ts.
};
